import React from "react";

import MemberTBody from "./MemberTBody";
import {
  TableContainer,
  TableHeader,
  TableBody,
} from "../styled/userManagement/UserManageStyle";

export default function MemberTable({ memberManagementData, onDataChange }) {
  return (
    <TableContainer>
      <TableHeader>
        <li>순번</li>
        <li>이메일</li>
        <li>기관/기업명</li>
        <li>가입일</li>
        <li>상태</li>
        <li>권한관리</li>
      </TableHeader>
      <TableBody>
        {memberManagementData.map((member, index) => (
          <MemberTBody
            key={member.id || index}
            member={member}
            index={index}
            onDataChange={onDataChange}
          />
        ))}
      </TableBody>
    </TableContainer>
  );
}
